
import {Component, Vue} from "vue-property-decorator";
import UploadKeysCategories from "@/components/admin/UploadKeysCategories.vue";
import UploadKeysTags from "@/components/admin/UploadKeysTags.vue";

@Component({
  components: {
    UploadKeysCategories,
    UploadKeysTags,
  },
  })
export default class AdminPage extends Vue {

  private toggleProtectionActive: boolean = false;

public async mounted() {
  await this.protectionState();
}
  // envoi de l'état du bouton
  private async onToggleProtection() {
  await this.$store.dispatch("admin/administration/postProtectionState", {
    params: { active: this.toggleProtectionActive},
  }).then((res) => {
      this.toggleProtectionActive = res.protectionIsReady;
    });

}
  // récupère l'état de la protection
  private async protectionState() {
    await this.$store.dispatch("admin/administration/getProtectionState",
    ).then((res) => {
      this.toggleProtectionActive = res.protectionIsReady;
    });
    }
}
